/**
 * Created by StoneWang on 2020/11/27.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import {
  Row,
  Col,
  Icon,
  Form,
  Input,
  Select,
  Button,
  message,
  Checkbox,
} from 'antd';
import {
  DmsTab,
  MyUpload,
} from 'Components';
import { customerList } from '../../service/shoppingCar';
import {
  advertDetail,
  addAdvertPublish,
  modifyAdvertPublish,
} from '../../service/carousel';
import {
  showSpin,
  hideSpin,
  config
} from 'Utils';
import { typeMap } from './constant';

const CheckboxGroup = Checkbox.Group;
const FormItem = Form.Item;
const { TextArea } = Input;

class AddNotice extends React.Component {
  constructor(props) {
    super(props);
    const currentChannel = window.sessionStorage.getItem('cur_channel') || '';
    this.channelCode = currentChannel.split('|')[1] || '';
    this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
    this.id = props.params.id === '0' ? 0 : props.params.id;
    this.state = {
      picList: [],
      detail: {},
      htmlContent: '',
      // customerList: [],
    };
    this.normFile = this.normFile.bind(this);
    this.submitHandle = this.submitHandle.bind(this);
  }

  /*componentWillMount() { //准备数据
    const self = this;
    customerList(self.channelCode).then(res => { //
      if (res.status && res.code == 200) {
        const list = (res.data || []).map(x => ({ value: `${x.id}`, text: x.name }));
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({
              customerList: list,
            });
          }
        }, 200);
      } else {
        message.error(res.message);
      }
    });
  }*/

  componentDidMount() {
    this.mounted = true;
    if (this.id > 0) {
      advertDetail({ id: this.id }).then(res => {
        if (res.status) {
          let data = res.data;
          data = {
            ...data,
            // { key: "lucy", label: "Lucy (101)" }
            // customerId: {
            //   key: data.customerId ? `${data.customerId}` : undefined,
            //   label: data.customerName || ''
            // },
            customerId: data.customerId || '',
            customerName: data.customerName || '',
            type: data.type ? data.type.split(',') : [],
            picInfo: JSON.parse(data.picInfo || "[]")
          }
          this.setState({
            detail: data,
            picList: (data.picInfo || []).map(x => ({
              id: x.pid,
              url: x.purl,
              href: x.linkAddr || '',
            }))
          }, () => {
            let fileList = (data.picInfo || []).map((x, index) => ({
              uid: 0 - index -1,
              name: 'xxx.png',
              status: 'done',
              id: x.pid,
              url: `${config.server}${x.purl}`,
              thumbUrl: `${config.server}${x.purl}`,
              extraData: x.linkAddr
            }));
            this.props.form.setFieldsValue({ pics: fileList })
          });
        }
      });
    }
  }

  cancelHandle() {
    hashHistory.goBack();
  }

  submitHandle() {
    const { validateFields, getFieldsValue } = this.props.form;
    validateFields((errors) => {//表单校验
      if (errors) {
        return;
      }//表单校验有误，则不执行下面的代码
      const data = getFieldsValue();
      const params = {
        customerId: data.customerId,
        customerName: data.customerId,
        content: data.content,
        type: data.type.join(),
        picInfo: (data.pics || []).map(x => ({
          pid: x.id,
          purl: x.url.replace(/http(s)?:\/\/\S+\/xweb\//, '/'),
          linkAddr: x.extraData,
        }))
      };
      params.picInfo = JSON.stringify(params.picInfo);
      // console.log(`你正在提交数据：${JSON.stringify(data)}`);
      showSpin();
      if (this.id > 0) {
        modifyAdvertPublish({ ...params, id: this.id }).then(res => {
          hideSpin();
          message[res.status ? 'success' : 'error'](res.message);
          res.status && hashHistory.goBack();
        });
      } else {
        addAdvertPublish(params).then(res => {
          hideSpin();
          message[res.status ? 'success' : 'error'](res.message);
          res.status && hashHistory.goBack();
        });
      }
    });
  }

  normFile = (fileList) => {
    this.setState({
      picList: (fileList || []).filter(x => x.status === 'done').map(x => ({
        id: x.id,
        url: x.url,
        href: x.extraData || '',
      })),
    });
    return fileList || [];
  };

  onHrefChange(e, id) {
    const { getFieldValue, setFieldsValue } = this.props.form;
    const { picList } = this.state;
    let index = picList.findIndex(x => x.id === id);
    if (index > -1) {
      const pics = getFieldValue('pics');
      pics.splice(index, 1, { ...pics[index], extraData: e.target.value });
      picList.splice(index, 1, { ...picList[index], href: e.target.value });
      this.setState({
        picList: [...picList],
      }, () => {
        setFieldsValue({ pics: pics }); // 同步修改表单字段
      });
    }
  }

  render() {
    const { detail, picList, customerList } = this.state;
    const { getFieldDecorator } = this.props.form;
    const typeOptions = Object.keys(typeMap).map(key => ({ label: typeMap[key], value: key }));
    const myUploadProps = {
      maxWidth: 360,
      maxHeight: 235,
      maxSize: 1,
      maxCount: 5,
      antdUploadProps: {
        className: 'my-picture-card',
        listType: 'picture-card',
        showUploadList: { showRemoveIcon: true, showPreviewIcon: false },
      },
    };
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">点击上传</div>
      </div>
    );
    return <div className="dms-body">
      <DmsTab options={[`${this.id === 0 ? '新建广告' : '编辑广告'}`]} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col className="gutter-row" span={8}>
              <div style={{display: 'none'}}>
                <FormItem label="客户名称ID：" hasFeedback>
                  {getFieldDecorator('customerId', {
                    initialValue: this.userData.empId || undefined,
                  })(<Input disabled={true} />)}
                </FormItem>
              </div>
              <FormItem label="客户名称：" hasFeedback>
                {getFieldDecorator('customerName', {
                  initialValue: this.userData.userName || undefined,
                })(<Input disabled={true} />)}
              </FormItem>
              {/*<FormItem label="客户名称：" hasFeedback>
                {getFieldDecorator('customerId', {
                  initialValue: detail.customerId || undefined,
                  rules: [
                    {
                      required: true,
                      message: '请选择客户',
                    },
                  ],
                })(<Select labelInValue placeholder="请选择客户">
                  {customerList.map(x => <Select.Option key={x.value}>{x.text}</Select.Option>)}
                </Select>)}
              </FormItem>*/}
            </Col>
            <Col className="gutter-row" span={8}>
              <FormItem label="类型：" hasFeedback>
                {getFieldDecorator('type', {
                  initialValue: detail.type || ['1'],
                  rules: [
                    {
                      required: true,
                      message: '请选择类型',
                    },
                  ],
                })(<CheckboxGroup options={typeOptions} />)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={8}>
              {!!this.id && <FormItem label="发布时间：" hasFeedback>
                <span>{detail.publishDate}</span>
              </FormItem>}
            </Col>
            <Col className="gutter-row" span={8}>&emsp;</Col>
          </Row>
          <FormItem label="广告描述：" hasFeedback>
            {getFieldDecorator('content', {
              initialValue: detail.content || undefined,
              rules: [
                {
                  required: true,
                  message: '请输入广告描述',
                  min: 1,
                  max: 128,
                },
              ],
            })(<TextArea rows={4} placeholder="请输入广告描述" />)}
          </FormItem>
          <FormItem label={<span>广告图片：<span className="gray">建议图片大小 : 360x235px，最多不超过5张</span></span>}
                    hasFeedback
                    colon={false}
                    extra={
                      <span>
                        {picList.map(x => <Input
                          key={x.id}
                          value={x.href}
                          placeholder="链接地址"
                          className="my-picture-card-input"
                          onChange={(e) => this.onHrefChange(e, x.id)} />)}
                      </span>
                    }>
            {getFieldDecorator('pics', {
              // valuePropName: 'fileList',
              getValueFromEvent: this.normFile,
              rules: [
                {
                  required: true,
                  message: '请上传广告图片',
                },
              ],
            })(<MyUpload {...myUploadProps}>
              {uploadButton}
            </MyUpload>)}
          </FormItem>
        </Form>
      </div>
    </div>;
  }
}

export default Form.create()(AddNotice);



// WEBPACK FOOTER //
// ./src/routes/carousel/add.js